var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CardBase", { attrs: { border: "border-bottom" } }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center", style: { gap: "12px" } },
        [
          _vm.goBackRoute != null
            ? _c(
                "el-link",
                { attrs: { underline: false, href: _vm.goBackRoute } },
                [
                  _c("i", { staticClass: "el-icon-back" }),
                  _vm._v("\n            Voltar\n        ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _vm.icon
                ? _c(
                    "el-tag",
                    { staticClass: "mr-2", attrs: { type: "info" } },
                    [_c("i", { class: _vm.icon })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title
                ? _c("h5", { staticClass: "font-weight-semibold mb-0" }, [
                    _vm._v(_vm._s(_vm.title))
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-items-center", style: { gap: "12px" } },
        [_vm._t("actions")],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-574ddf1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-574ddf1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/MacroSubHeader.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-574ddf1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/MacroSubHeader.vue
// module chunks = 2